const getStore = (type) => {
  if (typeof window === 'undefined') return null;
  try {
    return type === 'local' ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
};

export const getLocalItem = (key) => {
  const store = getStore('local');
  if (!store) return '';
  try {
    return store.getItem(key) || '';
  } catch {
    return '';
  }
};

export const setLocalItem = (key, value) => {
  const store = getStore('local');
  if (!store) return false;
  try {
    store.setItem(key, value);
    return true;
  } catch {
    return false;
  }
};

export const removeLocalItem = (key) => {
  const store = getStore('local');
  if (!store) return false;
  try {
    store.removeItem(key);
    return true;
  } catch {
    return false;
  }
};

export const getSessionItem = (key) => {
  const store = getStore('session');
  if (!store) return '';
  try {
    return store.getItem(key) || '';
  } catch {
    return '';
  }
};

export const setSessionItem = (key, value) => {
  const store = getStore('session');
  if (!store) return false;
  try {
    store.setItem(key, value);
    return true;
  } catch {
    return false;
  }
};

export const removeSessionItem = (key) => {
  const store = getStore('session');
  if (!store) return false;
  try {
    store.removeItem(key);
    return true;
  } catch {
    return false;
  }
};
